document.addEventListener("turbolinks:load", function () {
    const header = document.getElementById("proxySystemHeader");
    if (!header) return; // Ensure script only runs on the proxy voting page

    // Map links to their respective section IDs
    const linksToHeaders = {
      "Association Requirements": "association_setup",
      "Proxy Holder Setup": "proxy_holder_setup",
      "Proxy Granting and Casting Vote": "proxy_granting_and_casting_vote"
    };

    // Add smooth scroll to each link
    Object.entries(linksToHeaders).forEach(([ariaLabel, targetId]) => {
      const link = document.querySelector(`a[aria-label="${ariaLabel}"]`);
      const targetElement = document.getElementById(targetId);

      if (link && targetElement) {
        link.addEventListener("click", function (event) {
          event.preventDefault();
          window.scrollTo({
            top: targetElement.offsetTop - 100, // Adjust for sticky headers
            behavior: "smooth"
          });
        });
      }
    });

    // Optional: show scroll-to-top button
    const scrollToTopBtn = document.getElementById("scrollToTop");
    if (scrollToTopBtn) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 300) {
          scrollToTopBtn.classList.remove("hidden");
        } else {
          scrollToTopBtn.classList.add("hidden");
        }
      });

      scrollToTopBtn.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  });
